import { useEffect, useRef } from "react";
import { ModalProps } from "../../types";

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  height,
  width = "w-[100%]",
  maxWidth,
  extraClassName,
  disableCancel,
}) => {
  const ModalRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (ModalRef.current && !ModalRef.current.contains(event.target as Node)) {
      onClose?.();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  if (!isOpen) return null;
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm backdrop-brightness-75 ${
        isOpen ? "animate-modal-backdrop-in" : "animate-modal-backdrop-out"
      } `}
    >
      <div
        ref={ModalRef}
        className={`min-w-xs shadow-custom relative flex flex-col gap-2 rounded-2xl bg-white p-6 ${height} ${width} ${maxWidth ? maxWidth : "max-w-lg"} ${extraClassName} ${
          isOpen ? "animate-modal-in" : "animate-modal-out"
        } `}
      >
        {!disableCancel && (
          <button
            className="absolute end-5 top-2 text-3xl text-gray-500 transition hover:text-gray-700"
            onClick={onClose}
          >
            &times;
          </button>
        )}

        {children}
      </div>
    </div>
  );
};

export default Modal;
